import React from 'react';
import Register from './Registationpage'; // Importing the Register component
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa'; // Import icons
import '../Components/style/contact.css';

function Contact() {
  const styles = {
    page: {
      background: 'linear-gradient(135deg, #dfe9fd 0%, #f4f7fe 55%, #ffffff 100%)',
      padding: '70px 24px',
      position: 'relative',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    card: {
      position: 'relative',
      zIndex: 2,
      backgroundColor: '#ffffff',
      borderRadius: '32px',
      maxWidth: '1100px',
      width: '100%',
      padding: '60px 55px',
      boxSizing: 'border-box',
      border: '1px solid #e3ebfd',
      overflow: 'hidden',
    },
    shape: {
      position: 'absolute',
      opacity: 0.5,
      zIndex: 0,
    },
    heading: {
      textAlign: 'center',
      fontFamily: "'Playfair Display', Georgia, serif",
      fontSize: '34px',
      fontWeight: 700,
      color: '#0f1e4d',
      marginBottom: '10px',
      letterSpacing: '0.3px',
      position: 'relative',
      zIndex: 2,
    },
    subheading: {
      textAlign: 'center',
      fontSize: '15px',
      color: '#6b7280',
      maxWidth: '560px',
      margin: '0 auto 44px auto',
      lineHeight: 1.7,
      position: 'relative',
      zIndex: 2,
    },
    registerWrap: {
      position: 'relative',
      zIndex: 2,
      marginBottom: '48px',
    },
    formShell: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      gap: '20px',
      backgroundColor: '#f8faff',
      border: '1px solid #e3ebfd',
      borderRadius: '18px',
      padding: '30px 28px',
    },
    fieldGroup: {
      flex: '1 1 200px',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },
    label: {
      fontSize: '12.5px',
      fontWeight: 600,
      color: '#0f1e4d',
      letterSpacing: '0.3px',
      textTransform: 'uppercase',
    },
    input: {
      border: 'none',
      borderBottom: '1.5px solid #c9d6f5',
      backgroundColor: 'transparent',
      padding: '8px 2px',
      fontSize: '14.5px',
      color: '#111827',
      outline: 'none',
    },
    submitBtn: {
      flex: '0 0 auto',
      backgroundColor: '#0f1e4d',
      color: '#ffffff',
      border: 'none',
      borderRadius: '10px',
      padding: '14px 30px',
      fontSize: '14.5px',
      fontWeight: 700,
      letterSpacing: '0.3px',
      cursor: 'pointer',
      height: '46px',
    },
    contactInfo: {
      textAlign: 'center',
      position: 'relative',
      zIndex: 2,
    },
    methodsRow: {
      display: 'flex',
      justifyContent: 'center',
      gap: '48px',
      flexWrap: 'wrap',
      marginTop: '10px',
    },
    method: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
    },
    iconCircle: {
      width: '52px',
      height: '52px',
      borderRadius: '50%',
      backgroundColor: '#e3ebfd',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#0f1e4d',
    },
    methodText: {
      fontSize: '14.5px',
      color: '#4b5563',
    },
    methodLink: {
      color: '#0f1e4d',
      fontWeight: 700,
      textDecoration: 'none',
    },
  };

  return (
    <div style={styles.page}>
      <div className="contact-container" style={styles.card}>
        {/* Decorative shapes now live on the rectangle card itself */}
        <div style={{ ...styles.shape, top: '20px', left: '30px', width: '46px', height: '46px', borderRadius: '12px', backgroundColor: '#dfe9fd', transform: 'rotate(18deg)' }} />
        <div style={{ ...styles.shape, top: '40px', right: '60px', width: '38px', height: '38px', borderRadius: '50%', backgroundColor: '#e3ebfd' }} />
        <div style={{ ...styles.shape, bottom: '30px', left: '60px', width: '34px', height: '34px', borderRadius: '50%', backgroundColor: '#dfe9fd' }} />
        <div style={{ ...styles.shape, bottom: '24px', right: '40px', width: '40px', height: '40px', borderRadius: '10px', backgroundColor: '#e3ebfd', transform: 'rotate(-12deg)' }} />

        <h2 style={styles.heading}>Contact Us</h2>
        <p style={styles.subheading}>
          Have any questions? Fill out the form below or reach out to us directly through phone or email.
        </p>

        {/* Registration Form Section */}
        <section className="register-section" style={styles.registerWrap}>
          {/*
            TEMPORARY: Your original <Register /> component is preserved below,
            commented out, so nothing is lost. Once you share Registationpage.jsx,
            I will restyle its actual fields into this horizontal shell instead
            of this placeholder markup.
          */}
          {/* <Register /> */}

          <div style={styles.formShell}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Name</label>
              <input style={styles.input} type="text" placeholder="Your name" />
            </div>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} type="email" placeholder="you@example.com" />
            </div>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Phone</label>
              <input style={styles.input} type="text" placeholder="Phone number" />
            </div>
            <div style={{ ...styles.fieldGroup, flex: '2 1 260px' }}>
              <label style={styles.label}>Message</label>
              <input style={styles.input} type="text" placeholder="How can we help?" />
            </div>
            <button style={styles.submitBtn}>Send Message</button>
          </div>
        </section>

        {/* Contact info */}
        <section className="contact-info" style={styles.contactInfo}>
          <div className="contact-methods" style={styles.methodsRow}>
            <div className="contact-method" style={styles.method}>
              <div style={styles.iconCircle}>
                <FaPhoneAlt size={20} />
              </div>
              <p style={styles.methodText}>
                Phone:{' '}
                <a href="tel:91 xxxxxxx" aria-label="Phone" style={styles.methodLink}>
                  91 xxxxxxxx
                </a>
              </p>
            </div>

            <div className="contact-method" style={styles.method}>
              <div style={styles.iconCircle}>
                <FaEnvelope size={20} />
              </div>
              <p style={styles.methodText}>
                Email:{' '}
                <a href="mailto:info@orryx.in" aria-label="Email" style={styles.methodLink}>
                  info@orryx.in
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Contact;